import { createSlice, createSelector } from "@reduxjs/toolkit";

const marketingMessage = createSlice({
    name: "marketingMessageSlice",
    initialState: null,
    reducers: {
        setMarketingMessage(_, action) {
            return action.payload;
        },
    },
});

export default marketingMessage.reducer;

export const { setMarketingMessage } = marketingMessage.actions;

////////////////////////////
//   selector-functions   //
////////////////////////////

const selectSelf = state => state.marketingMessage;

export const getMarketingMessage = createSelector(
    selectSelf,
    state => state || null,
);
